<template>
  <landing-page></landing-page>
</template>

<script>
import LandingPage from "../components/LandingPage/LandingPage";
export default {
  name: "Home",
  components: {
    "landing-page": LandingPage
  }
};
</script>

<style>
</style>
